import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ClearO = function ClearO(_ref) {
  var className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    ignoreColor = _ref.ignoreColor,
    _ref$innerColor = _ref.innerColor,
    innerColor = _ref$innerColor === void 0 ? '#fff' : _ref$innerColor;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    children: /*#__PURE__*/_jsxs("g", {
      fillRule: "evenodd",
      children: [/*#__PURE__*/_jsx("circle", {
        cx: "8",
        cy: "8",
        r: "8",
        fill: !ignoreColor ? color : undefined
      }), /*#__PURE__*/_jsx("path", {
        fill: !ignoreColor ? innerColor : undefined,
        d: "M7.85882353,0.141010576 C7.67058824,-0.0470035253 7.35058824,-0.0470035253 7.14352941,0.141010576 L4,3.28084606 L0.856470588,0.141010576 C0.668235294,-0.0470035253 0.348235294,-0.0470035253 0.141176471,0.141010576 C-0.0470588235,0.329024677 -0.0470588235,0.648648649 0.141176471,0.85546416 L3.28470588,3.99529965 L0.141176471,7.13513514 C-0.0470588235,7.32314924 -0.0470588235,7.64258519 0.141176471,7.84958872 C0.235294118,7.94359577 0.367058824,8 0.498823529,8 C0.630588235,8 0.762352941,7.94359577 0.856470588,7.84958872 L4,4.70975323 L7.14352941,7.84958872 C7.23764706,7.94359577 7.36941176,8 7.50117647,8 C7.63294118,8 7.76470588,7.94359577 7.85882353,7.84958872 C8.04705882,7.66157462 8.04705882,7.34195065 7.85882353,7.13513514 L4.71529412,3.99529965 L7.85882353,0.85546416 C8.04705882,0.667450059 8.04705882,0.347826087 7.85882353,0.141010576",
        transform: "translate(4 4)"
      })]
    })
  });
};
export default ClearO;